var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.53414 8.0139L0.304051 1.78363C-0.101393 1.37838 -0.101393 0.723143 0.304051 0.31789C0.709306 -0.0873629 1.36454 -0.0873629 1.7698 0.31789L8.00008 6.54816L14.2302 0.31789C14.6356 -0.0873629 15.2907 -0.0873629 15.6959 0.31789C16.1014 0.723143 16.1014 1.37838 15.6959 1.78363L9.46583 8.0139L15.6959 14.2442C16.1014 14.6494 16.1014 15.3047 15.6959 15.7099C15.494 15.9121 15.2284 16.0136 14.963 16.0136C14.6977 16.0136 14.4323 15.9121 14.2302 15.7099L8.00008 9.47964L1.7698 15.7099C1.56765 15.9121 1.30229 16.0136 1.03693 16.0136C0.771564 16.0136 0.506205 15.9121 0.304051 15.7099C-0.101393 15.3047 -0.101393 14.6494 0.304051 14.2442L6.53414 8.0139Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 16 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close-white.a5f269769f81f93cdabfcc63b3cbc106.svg";
export { ForwardRef as ReactComponent };